import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Stock } from '../model/Stock';
import { GLOBAL } from './global';
import { FilterUrlService } from './filter-url.service';
import 'rxjs/add/operator/map';

@Injectable()
export class StockService {
  url_stock:string;
  stock_list:any;
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this.url_stock = GLOBAL.url+"stock";
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }

  public getStock(){
    return this.http.get(this.url_stock ).map( res => {
        this.stock_list = res;
        return this.stock_list;
    });
  }

  public getDataFiltered(filters){
    //console.log("FILTROS STOCK: ", filters);
    let url = GLOBAL.url+'stock_summary'+filters;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getDataFiltered2(filters){
    //console.log("FILTROS STOCK 2: ", filters);
    let url = GLOBAL.url+'stock_summary'+filters+'&limit=20';
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getDataFiltered3(filters){
    //console.log("FILTROS 3: ", filters);
    let url = GLOBAL.url+'stock_summary'+filters;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getDataFilteredInputs(filters){
    let url = GLOBAL.url+'stock_inputs'+filters;
      //console.log("URL DE Filtro ", url);
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getDataFiltered3Outputs(filters){
    let url = GLOBAL.url+'stock_outputs'+filters;
    //console.log("URL DE Filtro Salidas: ", url);
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getStock2(token:string){
    return this.http.get(this.url_stock ).map( res => {
        this.stock_list = res;
        return this.stock_list;
    });
  }

  public getStock3(token:string){
    return this.http.get(this.url_stock+'/16' ).map( res => {
        this.stock_list = res;
        return this.stock_list;
    });
  }

  public getOneStock(p:string,s:string){
    let url = GLOBAL.url+'stock_by_tag?prefix='+p+'&suffix='+s;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getOneStockTrack(p:string,s:string){
    let url = GLOBAL.url+'track_by_tag?prefix='+p+'&suffix='+s;
    return this.http.get(url).map((res)=>{
      return res;
    })
  }

  public getOneStockByDeleted(prefijo:string,sufijo:string){
    let url = GLOBAL.url+'stock_by_deleted?prefix='+prefijo+'&suffix='+sufijo;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getOneSaldoStock(p:string,s:string){
    let url = GLOBAL.url+'stock_by_union?prefix='+p+'&suffix='+s;
    return this.http.get(url ).map( res => {
      return res;
    });
  }


  public getExcel(){
    return GLOBAL.url+'stock_excel';
  }

  public getExcel2(){
    return GLOBAL.url+'stock_excel_movements';
  }

  public getAllStockFromPallet(id:number){
    let url = GLOBAL.url+'stock?pallet_id='+id+'&limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockSummary(){
    let url = GLOBAL.url+'stock_summary'+this.filter;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockSummary2(filter){
    //console.log("Filtro stock summary enabled = 0: ",this.filter);
    let url = GLOBAL.url+'stock_summary'+filter;

    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockSummaryDisponible(filter){
    //console.log("Filtro stock summary enabled = 1: ",this.filter);
    let url = GLOBAL.url+'stock_summary'+filter;

    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockByLocation(id:string){
    let url = GLOBAL.url+'stock?location_id='+id;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockDataGraph(){
    let url = GLOBAL.url+'stock_locations';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockOutputs(){
    let url = GLOBAL.url+'stock_outputs';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockInputs(){
    let url = GLOBAL.url+'stock_inputs';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockExitReasons(){
    let url = GLOBAL.url+"reasons?reason_type_id=2&limit=50";
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getStockFormulaCS(){
    let url = GLOBAL.url+"stock_formula";
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public save(prov:any){
    return this.http.post(this.url_stock, prov)
      .map( data => {
        return data;
      });
  }

  /**
  * Envia un POST para almacenar información de varios cajas a la vez.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public saveAll(prov:any){
    let url = GLOBAL.url+"all_stock";
    return this.http.post(url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Envia un POST para almacenar información de varios cajas a la vez.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public saveAllDevolucion(prov:any){
    let url = GLOBAL.url+"stock_give_back";
    return this.http.put(url, prov)
    .map( data => {
      return data;
    });
  }

  public update(url:string, body){
    return this.http.put(url, body)
      .map( data => {
        return data;
      });
  }

  /**
  * Envia un PUT para almacenar información de varios cajas a la vez.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public updateAll(prov:any){
    let url = GLOBAL.url+"all_stock";
    return this.http.put(url, prov)
    .map( data => {
      return data;
    });
  }

  public deleteAllStockFromPallet(prov){
    let url = GLOBAL.url+"all_pallets_in_delete";
    return this.http.put(url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Actualiza la ubicacion de una caja en la base de datos.
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public update2(body,id){
    let url = GLOBAL.url+"stock/"+id;
    return this.http.put(url, body)
    .map( data => {return data;});
  }

  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });
  }

  /**
  * Envia un delete para almacenar información de varios cajas a la vez.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public deleteAll(prov:any){
    let url = GLOBAL.url+"all_stock_delete";
    return this.http.put(url, prov)
    .map( data => {
      return data;
    });
  }

/**
 * Borra una caja del stock relacionada con el id del Pallet.
 * @param  id  Id del pallet.
 * @return     Respuesta del servidor.
 */
  public delete2(id:number){
    let url = GLOBAL.url+'stock/'+id;
    return this.http.delete(url).map( response =>{
      return response;
    });
  }

  transformData(tag:any,idpallet:number,pallet:any){
    //id,pallet,tag,status,location,locationid,positionid
    let p = new Stock(null,idpallet,tag.id,1,pallet.ubicacionid,pallet.positionid);
    return p.getJson();
  }

  transformData2(tag:any,idubicacion:number,idposicion:any){
    //id,pallet,tag,status,location,locationid,positionid
    let p = new Stock(null,null,tag.id,1,idubicacion,idposicion);
    return p.getJson();
  }

  transformData3(box:any){
    //id,pallet,tag,status,location,locationid,positionid
    let p = new Stock(box.id,box.idpallet,box.idtag,1,box.idubicacion,box.idposicion);
    return p.getJson();
  }

  transformData4(id,idpallet,idtag,idubicacion,idposicion){
    //id,pallet,tag,status,location,locationid,positionid
    let p = new Stock(id,idpallet,idtag,1,idubicacion,idposicion);
    return p.getJson();
  }

  transformData5(tag:any,idubicacion:number,idposicion:any){
    //id,pallet,tag,status,location,locationid,positionid
    let p = new Stock(null,null,tag.id,1,idubicacion,idposicion);
    return p.getJson2();
  }

  transformData6(idpallet,idtag,idstatus,idposicion,obs){
    //id,pallet,tag,status,location,locationid,positionid
    let p = new Stock(null,idpallet,idtag,idstatus,null,idposicion);
    return p.getJson3(obs);
  }
  /**
  * Transforma un varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData7(pallet){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJson4(pallet);
  }

  /**
  * Transforma un varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData8(cajas,posicionesvacias){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJson5(cajas,posicionesvacias);
  }

  /**
  * Transforma un varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData9(cajas,pallet){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJson6(cajas,pallet);
  }

  /**
  * Elimina uno o varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData10(cajas,reason,guia,cliente){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJson7(cajas,reason,guia,cliente);
  }

  /**
  * Elimina uno o varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformDataOrdenSalidaStock(cajas,reason){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJsonOrdenSalidaStock(cajas,reason);
  }

  /**
   * Elimina todas las cajas de uno o varios pallets
   * @param  pallet [description]
   * @param  guia   [description]
   * @param  razon  [description]
   * @return        [description]
   */
  transformData11(pallets,cliente){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJson8(pallets,cliente);
  }

  transformDataDevolucion(cajas:any[]){
    let p = new Stock(null,0,0,0,null,0);
    return p.getJsonDevolucion(cajas);
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/stock.service.ts